import React from 'react';
// import TagManager from 'react-gtm-module';
// import { Helmet } from 'react-helmet-async';
import SEO from '../../SEO/SEO';

import './home.scss';
import Slide from '../../components/Slide';
import aboutone from './pictures/about/matriz (1).jpeg';
import aboutwo from './pictures/about/300.png';   
import { useFormik } from 'formik';
import Projetos from '../../components/Projetos';
import Ouvidoria from '../../components/Ouvidoria';
import Main from '../../components/Cards';

// Images customers
import vale from './pictures/customers/vale.png';
import hydro from './pictures/customers/hydro.png';
import alunorte from './pictures/customers/alunorte.png';
import oz from './pictures/customers/oz.jpeg'
import bhp from './pictures/customers/bhp.png'
import ArticleSection from '../../components/Artigos';
import valeMetal from '../../pages/Home/pictures/customers/vale-metal.jpg'

import relatorioImg from "../../assets/pictures/RelatorioIgualdadeSalarialLote_2025_2_83934067000120-1.png"

import Infos from '../../components/Infos';

// import Infos from '../../components/Infos';
import CronologiaSeculos from '../../components/Cronologia'

// fuction validate form
const validate = values => {
  const errorMsg = "Deve ter 20 caracteres ao menos";
  const errorMessage = "Sua mensagem deve quer ao menos 60 caracteres";
  const errors = {};

    if(!values.name){
    errors.name = "Required";
  }else if(values.name.lenght > 20){
    errors.name = errorMsg;
  }

  if(!values.email){
    errors.email = "Required";
  }else if(values.email.lenght > 20){
    errors.email = errorMsg;
  }

  if(!values.message){
    errors.message = "Required";
  }else if(values.message.lenght > 60){
    errors.message = errorMessage;
  }
  
  return errors;
}

// Home Page
export default function Home(seo){
  // Variable customers pictures
  const customers = [vale, hydro, alunorte, oz, bhp, valeMetal]

  const image = [aboutone, aboutwo];

  // Variables Formik Forms
  const formik = useFormik({
    initialValues: {
      name: "",
      email:"",
      phone: "",
      city:"",
      message:"",
    },
    validate,
    onSubmit: values =>{
      alert(JSON.stringify(values, null, 5));
    }
  })

  return(
    <>
      <SEO/>
      <div className='slide'>
        <Slide/>
      </div>

      <section id='section-about' className='home'>
        <div className='container line-box'>
          <div className="box-about">
            <figure>
              <img
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0" 
                src={image[0]} className="img-1 img-fluid" 
                width="100%" height="412px" 
                alt="imagem 1" 
              />
              {/* <img
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0"
                src={image[1]} 
                className="img-2 img-fluid" 
                width="40%" 
                height="auto" 
                alt="imagem 2"
              /> */}
            </figure>
          </div>
          <div className="box-about">
            <div className="box-title">
              <div className='about-desc'>
                <h5
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >DESDE</h5>
                <h4
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >1995</h4>
              </div>
              <div className="about-desc">
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >Atuando com </p>
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">SUCESSO &amp;</h2>
                <h2 
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">TRABALHO</h2>
              </div>
            </div>
            <div className="text-about">
                <p className='text-red'
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                    Fundada em 25 de janeiro de 1995, em Belém, a SÉCULOS ENGENHARIA E SERVIÇOS é uma empresa genuinamente paraense com raízes na região. Em 2000, transferimos nossa sede para Parauapebas-PA, onde nos tornamos um parceiro estratégico do Complexo Minerador de Carajás. Em março de 2020, um novo capítulo começou sob a liderança de uma nova gestão. Com foco na excelência e certificação ISO,implementamos um planejamento estratégico visando a melhoria contínua em todas as operações.
                </p>
            </div>
          </div>
        </div>
      </section>

      <CronologiaSeculos />
      {/* <section id="relatorio-igualdade" className="relatorio-igualdade">
      <div className="container">
        <h3 
          data-aos="fade-zoom-in"
          data-aos-duration="1000"
          data-aos-delay="300"
        >
          Relatório de Transparência e Igualdade Salarial
        </h3>
        <div className="relatorio-box">
          <img 
            src={relatorioImg} 
            alt="Relatório de Transparência e Igualdade Salarial"
            className="relatorio-img"
          />
        </div>
      </div>
    </section> */}

      <Infos />

    {/* section Projects */}
      <Projetos/>
      <section id="customers">
        <div className='container-customer'>
            <h3
              data-aos="fade-zoom-in" 
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0">
                Alguns de nossos clientes
            </h3>
          <div className='customers'>
            <div className='box-customers' 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <img src={customers[0]} width="180" alt="vale" />
            </div>
            <div className='box-customers' 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <img src={customers[1]} width="180" alt="hydro" />
            </div>
            <div className='box-customers' 
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <img src={customers[2]} width="180" alt="alunorte" />
            </div>
           
            <div className='box-customers'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <img src={customers[3]} width="180" alt="vale base metais" />
            </div>
            <div className='box-customers'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <img src={customers[4]} width="180" alt="oz minerals" />
            </div>
            <div className='box-customers'
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0">
              <img src={customers[5]} width="180" alt="bhp" />
            </div>
          </div>
        </div>
      </section>

      {/* Section Forms  */}
      <section id="forms">
        <div className="custom-shape-divider-top-1669943254">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
        </div>
          <div className='forms container'>
            <div className="box-form">
              <h3
                data-aos="fade-zoom-in" 
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offse="0"
                >Nossos diferenciais</h3>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >
                  Temos as melhores práticas de gestão, sustentabilidade e inovação para garantir a satisfação total de nossos clientes, além de contribuir para o desenvolvimento econômico, social e sustentável da região.
                </p>

                <h5
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >Serviços de qualidade com agilidade</h5>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >
                  Somos reconhecidos pela excelência em serviços ágeis e eficientes, mantendo o compromisso com a sustentabilidade e o atendimento ao cliente.
                </p>
                <h5
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >Certificação</h5>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0"
                >
                 Empresa certificada, conforme a ISO 9001-2015.
                </p>
            </div>
            <div className='box-form'>
              <div className="form" 
                data-aos="fade-up"
                data-aos-duration="1000"
                >
                <h4>Contate -nos</h4>
                <form onSubmit={formik.handleSubmit}>
                  <input 
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Nome"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                {formik.errors.name ? <div>{formik.errors.name}</div> : null}
                <br/>

                <br/>
                <input 
                  id="email"
                  name="email"
                  type="text"
                  placeholder="E-mail"
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                {formik.errors.email ? <div>{formik.errors.email}</div> : null}
                <br/>

                <br/>
                <input 
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="Telefone"
                  pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                />
                <br/>

                <br/>
                <input
                  id="city"
                  name="city"
                  type="text"
                  placeholder="Cidade"
                  onChange={formik.handleChange}
                  values={formik.values.city}
                />
                <br/>

                <br/>
                <textarea
                  id="message"
                  name="message"
                  type="text"
                  placeholder="Digite sua mensagem"
                  onChange={formik.handleChange}
                  value={formik.values.message}
                >
                </textarea>
                  {formik.errors.message? <div>{formik.errors.message}</div> : null}
                <br/>

                <button type="submit">Enviar</button>

                </form>
              </div>
            </div>
          </div>
      </section>
      <Main/>
      <ArticleSection/>
      <Ouvidoria/>
  </>
  )
}